import React from 'react';
import styled from 'styled-components/macro';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

interface FaqsAccordionProps {
  faqs: { title: string; content: React.ReactNode }[];
  backgroundColor?: string;
  textColor?: string;
  margin?: string;
  borderColor?: string;
}

export const Faqs = styled.div<{
  backgroundColor?: string;
  textColor?: string;
  margin?: string;
  borderColor?: string;
}>`
  width: 100%;
  max-width: 800px;

  margin: ${({ margin }) => margin || 'auto'};
  .faq-accordion {
    background: ${({ backgroundColor }) => backgroundColor || '#180d23'};
    color: ${({ textColor }) => textColor || '#fff'};
    border-bottom: 1px solid ${({ borderColor }) => borderColor || '#2d1a3a'};
    box-shadow: none;
    border-radius: 0;
    transition: all 0.5s ease;
    &:hover {
      h2.faq-title {
        color: #ff74e9;
      }
    }
  }
  h2.faq-title {
    margin: 5px;
    margin-top: 5px !important;
    font-weight: normal;
    font-size: 24px;
    padding: 0px;
    text-align: left;
    line-height: 1.3em;
    color: ${({ textColor }) => textColor || '#fff'};
  }
  p {
    margin: 10px;
    font-size: 20px;
    color: ${({ textColor }) => textColor || '#fff'};
  }
  a {
    color: #ff74e9;
  }
`;

export const FaqsAccordion: React.FC<FaqsAccordionProps> = ({
  faqs,
  backgroundColor,
  textColor,
  margin,
  borderColor,
}) => (
  <Faqs backgroundColor={backgroundColor} textColor={textColor} margin={margin} borderColor={borderColor}>
    {faqs.map((faq, idx) => (
      <Accordion className="faq-accordion" key={idx}>
        <AccordionSummary
          aria-controls={`panel${idx}-content`}
          id={`panel${idx}-header`}
        >
          <h2 className={"faq-title"}>{faq.title}</h2>
        </AccordionSummary>
        <AccordionDetails>
          {faq.content}
        </AccordionDetails>
      </Accordion>
    ))}
  </Faqs>
);
